import React, { useState, useEffect } from "react";
import {
  TOTAL_SCREENS,
  GET_SCREEN_INDEX,
  scrollToSection,
} from "../../../utilities/commonUtils";
import ScrollService from "../../../utilities/ScrollService";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.css";

export default function Header() {
  const [selectedScreen, setSelectedScreen] = useState(0);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);

  const updateCurrentScreen = (currentScreen) => {
    if (!currentScreen || !currentScreen.screenInView) return;

    let screenIndex = GET_SCREEN_INDEX(currentScreen.screenInView);
    if (screenIndex < 0) return;
    setSelectedScreen(screenIndex);
  };
  
  let currentScreenSubscription =
    ScrollService.currentScreenBroadcaster.subscribe(updateCurrentScreen);

  const getHeaderOptions = () => {
    return TOTAL_SCREENS.map((Screen, i) => (
      <div
        key={Screen.screen_name}
        className={getHeaderOptionsClasses(i)}
        onClick={() => switchScreen(i, Screen)}
      >
        <span>{Screen.screen_name}</span>
      </div>
    ));
  };

  const getHeaderOptionsClasses = (index) => {
    let classes = "header-option ";
    if (index < TOTAL_SCREENS.length - 1) classes += "header-option-seperator ";

    if (selectedScreen === index) classes += "selected-header-option ";

    return classes;
  };

  const switchScreen = (index, screen) => {
    if (scrollToSection(screen.screen_name)) {
      setSelectedScreen(index);
      setShowHeaderOptions(false);
    }
  };

  const toggleMenu = () => {
    setShowHeaderOptions(!showHeaderOptions);
  };

  useEffect(() => {
    return () => {
      currentScreenSubscription.unsubscribe();
    };
  }, [currentScreenSubscription]);

  // Close menu when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (window.innerWidth <= 970 && 
          showHeaderOptions && 
          !e.target.closest('.header-options') && 
          !e.target.closest('.header-hamburger') && 
          !e.target.closest('.header-hamburger-cross')) {
        setShowHeaderOptions(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showHeaderOptions]);

  return (
    <div className="header-container">
      <div className="header-parent">
        <div
          id="header-hamburger"
          className={`header-hamburger ${showHeaderOptions ? 'rotateIt' : ''}`}
          onClick={toggleMenu}
        >
          <FontAwesomeIcon className="header-hamburger-bars" icon={faBars} />
        </div>
        
       
        <div
          className={
            showHeaderOptions
              ? "header-options show-hamburger-options"
              : "header-options"
          }
        >
          <div
            id="header-hamburger-cross"
            className="header-hamburger-cross"
            onClick={toggleMenu}
          >
            <FontAwesomeIcon className="header-hamburger-bars" icon={faTimes} />
          </div>
          {getHeaderOptions()}
        </div>
      </div>
    </div>
  );
}